import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1BA39C',
      light: '#4DB8B3',
      dark: '#138E88',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#757575',
      light: '#A4A4A4',
      dark: '#494949',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
      dark: '#d32f2f',
    },
    warning: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#f57c00',
    },
    info: {
      main: '#2196f3',
      light: '#64b5f6',
      dark: '#1976d2',
    },
    success: {
      main: '#4caf50',
      light: '#81c784',
      dark: '#388e3c',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
  },
  typography: {
    fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '::placeholder': {
          color: '#C4C4C4 !important',
          opacity: '1 !important',
        },
        '::-webkit-input-placeholder': {
          color: '#C4C4C4 !important',
          opacity: '1 !important',
        },
        '::-moz-placeholder': {
          color: '#C4C4C4 !important',
          opacity: '1 !important',
        },
        ':-ms-input-placeholder': {
          color: '#C4C4C4 !important',
          opacity: '1 !important',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 4,
          padding: '8px 16px',
        },
        containedPrimary: {
          backgroundColor: '#1BA39C',
          '&:hover': {
            backgroundColor: '#138E88',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 48,
        },
        indicator: {
          backgroundColor: '#1BA39C',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          minHeight: 48,
          fontWeight: 400,
          '&.Mui-selected': {
            color: '#1BA39C',
            fontWeight: 600,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
              borderColor: '#1BA39C',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1BA39C',
            },
          },
          '& input::placeholder': {
            color: '#C4C4C4',
            opacity: 1,
          },
          '& textarea::placeholder': {
            color: '#C4C4C4',
            opacity: 1,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& input::placeholder': {
            color: '#C4C4C4',
            opacity: 1,
          },
          '& textarea::placeholder': {
            color: '#C4C4C4',
            opacity: 1,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#757575',
          '&.Mui-checked': {
            color: '#1BA39C',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#757575',
          '&.Mui-checked': {
            color: '#1BA39C',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: '#1BA39C',
            '& + .MuiSwitch-track': {
              backgroundColor: '#1BA39C',
            },
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#e0e0e0',
        },
        bar: {
          backgroundColor: '#1BA39C',
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#1BA39C',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
        elevation1: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

export default theme;
